import React from 'react';
import { Card, Typography, Button } from 'antd';

const { Title, Paragraph } = Typography;

const PageHeaderItem = ({ title, subtitle, onBack, extra }) => (
  <Card
    bordered={false}
    style={{ marginBottom: '16px', padding: '0px' }} // Apply padding here
  >
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div>
        {onBack && (
          <Button type="link" onClick={onBack} style={{ padding: 0, marginBottom: '8px' }}>
            Back
          </Button>
        )}
        <Title level={3} style={{ margin: 0 }}>
          {title}
        </Title>
        {subtitle && <Paragraph type="secondary">{subtitle}</Paragraph>}
      </div>
      {extra && <div>{extra}</div>}
    </div>
  </Card>
);

export default PageHeaderItem;